function* rootSaga() {
  // yield fork(watchFetchUser)
  // yield fork(watchLogin)
}

export default rootSaga;
